import { AxiosInstance } from "axios";
import { Method, Resource } from "../Resource";

export type WebhookRequest = {
  url?: string | null;
  enabled?: boolean;
  events?: string[] | null;
  description?: string | null;
};

export type Webhook = {
  id: string;
  url: string;
  enabled: boolean;
  events: string[];
  secret: string;
  description: string;
  createdAt: string;
  updatedAt: string;
};

export class Webhooks extends Resource<WebhookRequest> {
  constructor(axiosInstance: AxiosInstance) {
    super("webhooks", axiosInstance);
  }

  public async create(webhookRequest: WebhookRequest): Promise<Webhook> {
    return this.request({
      method: Method.POST,
      body: webhookRequest
    });
  }

  public async get(id: string): Promise<Webhook> {
    return this.request({ method: Method.GET, path: id });
  }

  public async update(
    id: string,
    webhookRequest: WebhookRequest
  ): Promise<Webhook> {
    return this.request({
      method: Method.POST,
      path: id,
      body: webhookRequest
    });
  }

  public async delete(id: string): Promise<void> {
    await this.request({ method: Method.DELETE, path: id });
  }

  public async list({
    page,
    pageSize
  }: {
    page?: number;
    pageSize?: number;
  } = {}): Promise<Webhook[]> {
    const { items: webhooks } = await this.request({
      method: Method.GET,
      query: { page, pageSize }
    });

    return webhooks;
  }
}
